import useQuestionTranslate from 'FlowBuilder/hooks/useQuestionTranslate'
import './Text.scoped.scss'

export default function Names({ response, setResponse, disabled, settings, placeholder = 'Type an answer...', question = {} }) {
  const splitNames = settings?.splitNames

  const { fallback: {
    firstNamePlaceholder: firstNameTranslated,
    lastNamePlaceholder: lastNameTranslated 
  } } = useQuestionTranslate({ questionOverride: question })
  

  if (splitNames) {
    const parsedResponse = typeof response === 'object' && response !== null
      ? response
      : { first_name: '', last_name: '' }

    const firstName = parsedResponse.first_name || ''
    const lastName = parsedResponse.last_name || ''

    return (
      <div className="answers grow">
        <div className="name-split" style={{ display: 'flex', gap: '10px' }}>
          <input
            type="text"
            placeholder={firstNameTranslated}
            value={firstName}
            onChange={(e) => setResponse({ first_name: e.target.value, last_name: lastName })}
            disabled={disabled}
            style={{ flex: 1 }}
          />
          <input
            type="text"
            placeholder={lastNameTranslated}
            value={lastName}
            onChange={(e) => setResponse({ first_name: firstName, last_name: e.target.value })}
            disabled={disabled}
            style={{ flex: 1 }}
          />
        </div>
      </div>
    )
  }

  // Single name field
  return (
    <div className="answers grow">
      <input
        placeholder={placeholder}
        onChange={(e) => setResponse(e.target.value)}
        type="text"
        disabled={disabled}
        value={response || ''}
      />
    </div>
  )
}
